import React, { useState } from "react";
import CTA from "./CTA";
import Form from "./Form";
import Banner from "../Banner";

const ContactUs = () => {
  return (
    <>
      <Banner name={"ContactUs"} Title={"Contact Us"} />
      {/* form */}
      <Form />
      {/* CTA */}
      <CTA />
      <div className="w-full h-96 mt-12">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.539241129903!2d78.55629707375252!3d17.48175380008252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b430adff967%3A0xd1169def98102e36!2sNew%20Directions%20Skills!5e0!3m2!1sen!2sin!4v1745924531383!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="New Directions Organization Location"
        ></iframe>
      </div>
    </>
  );
};

export default ContactUs;
